import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const OtaTrafficUsageWidget = lazy(() => import('.'))

class OtaTrafficUsageWidgetComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['project-id']
	}

	override render() {
		const projectId = this.prop('project-id')

		return (
			<AppProviders>
				<OtaTrafficUsageWidget projectId={projectId} legacy />
			</AppProviders>
		)
	}
}

customElements.define('ota-traffic-usage-widget', OtaTrafficUsageWidgetComponent)
